<script setup lang="ts">
withDefaults(
  defineProps<{
    columnCount?: number
    itemsPerColumn?: number
    showComex?: boolean
  }>(),
  {
    columnCount: 6,
    itemsPerColumn: 6,
    showComex: false,
  },
)
</script>

<template>
  <div class="national-org-grid-skeleton" aria-busy="true" aria-label="Chargement de l’organigramme">
    <div v-if="showComex" class="comex-bar comex-bar--skeleton" aria-hidden="true">
      <div class="item item--skeleton" />
    </div>
    <div class="columns-wrapper columns-wrapper--skeleton">
      <div class="columns-grid">
        <div v-for="colIndex in columnCount" :key="'sk-col-' + colIndex" class="col">
          <div class="col-header col-header--skeleton" />
          <div class="items-list">
            <div
              v-for="itemIndex in itemsPerColumn"
              :key="'sk-item-' + colIndex + '-' + itemIndex"
              class="item item--skeleton"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/orga/national-grid" as *;
@use "~/assets/scss/partials/elpdl/spacing" as *;

.comex-bar--skeleton {
  display: flex;
  justify-content: center;
}

.comex-bar--skeleton .item--skeleton {
  width: min(16rem, 80%);
  min-height: 3rem;
  border-radius: $spacing-2xs;
  background: var(--color-bg-muted);
}
</style>
